'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.modalContainerWidget = function () {
	return this.each(function () {
		const element = this;
		if (element.is('[data-mm-dismissible]')) {
			const dismissType = element.attr('data-mm-dismissible'),
				dismiss = function (evt) {
					evt.preventDefault();
					evt.stopPropagation();
					element.addClass('hidden');
				};
			if (dismissType !== 'buttonOnly') {
				element.on('keydown', function (e) {
					if (e.which === 27) {
						dismiss(e);
					}
				}).click(function (e) {
					if (e.target === this) {
						dismiss(e);
					}
				});
			}
			element.find('[data-mm-role~="dismiss"]').click(dismiss);
		};
		element.on('keydown', (evt) => {
			if (evt.which === 13) {
				const target = mmWidgets(evt.target),
					firstPrimaryAction = element.find('.primaryAction').visibleOnly().first();
				if (!target.is('A') && !target.is('BUTTON') && firstPrimaryAction.length) {
					evt.stopPropagation();
					evt.preventDefault();
					firstPrimaryAction.click();
				};
			}
		});
	});
};
